module.exports = __webpack_public_path__ + "static/media/nose.8c74f723.png";